import { Component, input } from '@angular/core';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { DataFieldComponent } from '@myarvato/shared/data-field';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'transport-detail-sidebar-references',
  imports: [DataFieldComponent, TranslatePipe],
  templateUrl: './details-sidebar-references.component.html',
  styleUrl: './details-sidebar-references.component.scss',
})
export class DetailsSidebarReferencesComponent {
  public readonly details = input.required<DetailViewDto>();
}
